(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dandyhat"] && !Shopify.designMode) return;
  try {
    
// Note: Assumes Flickity, PhotoSwipe, and a lazy-load script are loaded globally in theme.liquid
class DandyhatProduct {
  constructor(container) {
    this.container = container;
    this.variantIdInput = this.container.querySelector('[data-variant-id-input]');
    this.form = this.container.querySelector('.ProductForm');
    this.addToCartButton = this.container.querySelector('.ProductForm__AddToCart');
    this.addToCartText = this.container.querySelector('[data-add-to-cart-text]');
    this.quantityInputs = this.container.querySelectorAll('.quantity-input');
    
    this.init();
  }

  init() {
    // Logic for variant selection, quantity, and AJAX cart would go here.
    // This is a placeholder for the complex JS required.
    console.log('Dandyhat Product Section Initialized for section: ' + this.container.dataset.sectionId);

    // Example: Quantity Selector Logic
    this.container.querySelectorAll('[data-quantity-plus]').forEach(button => {
        button.addEventListener('click', () => {
            const input = button.previousElementSibling;
            input.stepUp();
        });
    });

    this.container.querySelectorAll('[data-quantity-minus]').forEach(button => {
        button.addEventListener('click', () => {
            const input = button.nextElementSibling;
            input.stepDown();
        });
    });
    
    // AJAX Cart Form Submission (requires a cart drawer/popup in the theme)
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();

        // Add loading state
        this.addToCartButton.classList.add('is-loading');

        const formData = new FormData(this.form);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Handle success - e.g., open cart drawer
          console.log('Product added:', data);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          // Remove loading state
          this.addToCartButton.classList.remove('is-loading');
        });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const productSections = document.querySelectorAll('[data-section-type="dandyhat-product-page"]');
  productSections.forEach(section => {
    new DandyhatProduct(section);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
